import { Alert, Snackbar } from '@mui/material';
import { createContext, ReactNode, useCallback, useContext, useState } from 'react';

type Severity = 'success' | 'error' | 'info' | 'warning';
interface ToastState {
  open: boolean;
  message: string;
  severity: Severity;
}

const ToastContext = createContext<(message: string, severity?: Severity) => void>(() => undefined);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<ToastState>({ open: false, message: '', severity: 'success' });
  const notify = useCallback((message: string, severity: Severity = 'success') => setState({ open: true, message, severity }), []);
  return (
    <ToastContext.Provider value={notify}>
      {children}
      <Snackbar open={state.open} autoHideDuration={5000} onClose={() => setState((s) => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Alert severity={state.severity} variant="filled" onClose={() => setState((s) => ({ ...s, open: false }))} sx={{ minWidth: 300 }}>
          {state.message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);
